import { Box, Stack, Typography } from "@mui/material";

import logoImage from "@/assets/nav_logo.png?inline";
import type { StatusPageTemplateProps } from "./StatusPage.template.types";
import * as styles from "./StatusPage.template.styles";

export type { StatusPageTemplateProps } from "./StatusPage.template.types";

/** Full-screen illustrated page shared by every error state and "coming soon". */
export function StatusPageTemplate({
  image,
  title,
  description,
  actions,
  overlay = false,
}: StatusPageTemplateProps) {
  return (
    <Box component="main" sx={styles.root(overlay)} role={overlay ? "alertdialog" : undefined}>
      {/* A plain anchor: the overlay variant can render outside the router. */}
      <Box component="a" href="/" sx={styles.logoLink} aria-label="سفانو">
        <Box component="img" src={logoImage} alt="سفانو" sx={styles.logo} />
      </Box>

      <Box sx={styles.content}>
        <Box component="img" src={image} alt="" sx={styles.image} />
        <Typography component="h1" sx={styles.title}>
          {title}
        </Typography>
        <Typography variant="body2" sx={styles.description}>
          {description}
        </Typography>
        {actions ? <Stack sx={styles.actions}>{actions}</Stack> : null}
      </Box>

      <Typography sx={styles.footer}>© سفانو</Typography>
    </Box>
  );
}
